import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=bd83c26e&scoped=true"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd83c26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd83c26e')) {
      api.createRecord('bd83c26e', component.options)
    } else {
      api.reload('bd83c26e', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=bd83c26e&scoped=true", function () {
      api.rerender('bd83c26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact-hold/dialog-form-wrapper.vue"
export default component.exports